// extracted by mini-css-extract-plugin
export default {"root":"RequestPasswordForm_root__daImr","emailInput":"RequestPasswordForm_emailInput__2LsYi"};